
import { computed, defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'files-name-icon',
  setup () {
    return {}
  }
})
